import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { ConfirmButton } from 'components/ui/Button';

import { ButtonWrapper, StyledTextarea } from '../ForcedCancellationModal/ForcedCancellationModal.styles';

const CheckinTicketsModal = ({ isOpen, isLoading, onToggle, onSubmit, ticketNumbers }) => {
  const { register, handleSubmit } = useForm();

  const handleOnSubmit = ({ reason }) => {
    onSubmit({
      reason
    });
  };

  return (
    <Modal isOpen={isOpen} title={<FormattedMessage id="checkinTickets.modal.title" />} onClose={onToggle}>
      <form onSubmit={handleSubmit(handleOnSubmit)} data-cy="checkin-tickets-form" data-testid="checkin-tickets-form">
        <h4 data-testid="checkin-tickets-form-tickets" data-cy="checkin-tickets-form-tickets">
          <FormattedMessage id="checkinTickets.modal.tickets" values={{ number: ticketNumbers.length, tickets: ticketNumbers }} />
        </h4>

        <p>
          <FormattedMessage id="checkinTickets.modal.paragraph" />
        </p>

        <StyledTextarea
          required
          rows="3"
          cols="40"
          data-testid="reason"
          data-cy="reason"
          {...register('reason', {
            required: true,
            min: 1,
            max: 37
          })}
        />

        <ButtonWrapper>
          <ConfirmButton type="submit" data-cy="submit" data-testid="submit" loading={isLoading} disabled={isLoading} variant="primary">
            <FormattedMessage id="checkinTickets.confirmCheckout" />
          </ConfirmButton>
        </ButtonWrapper>
      </form>
    </Modal>
  );
};

CheckinTicketsModal.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onToggle: PropTypes.func,
  onSubmit: PropTypes.func,
  ticketNumbers: PropTypes.arrayOf(PropTypes.string)
};

export default CheckinTicketsModal;
